'use strict';

angular.module('internal.licenses')
    .controller('InternalLicenseFormConditions', ['$scope', '$stateParams', '$q', 'FBConditions',
        function ($scope, $stateParams, $q, FBConditions) {
        $scope.resetForm();
        $scope.saving = false;
        $scope.loading = true;
        $scope.parameters = { license_id: $stateParams.id };

        var promises = [];

        if ($stateParams.formID != null) {
            promises.push(FBConditions.get({ formID: $stateParams.formID }).then(function (conditions) {
                $scope.conditions = conditions;
            }));
        }

        $scope.columns = [
            {
                label: 'Name',
                field: 'name',
                link: {
                    state: 'internal.licensing.license.form.condition',
                    params: [
                        {
                            name: 'conditionID',
                            field: 'id'
                        }
                    ]
                }
            },
            {
                label: 'Description',
                field: 'description'
            },
            {
                label: 'Trigger',
                field: 'trigger_name'
            }
        ];

        $q.all(promises).then(function () {
            $scope.loading = false;
        }).catch(function (response) {
            // handle error
        });

    }])
;